import I18N from '@leverege/i18n';
import CreateTemporaryUserAction from "./actions/CreateTemporaryUserAction.js";
import TemporaryUserLinkAction from "./actions/TemporaryUserLinkAction.js";
import TemporaryUserBreadcrumbRouteCreator from "./routes/TemporaryUserBreadcrumbRouteCreator.js";
import TemporaryUserRouteCreator from "./routes/TemporaryUserRouteCreator.js";
const {
  t,
  tIcon,
  tf,
  tfIcon
} = I18N.ns('molten.imagine.TemporaryUserAccess');

/**
 * Processes the relationship for temporary access management delegate. If the relationship blueprint has
 * the `has:tempUserManagement` tag, a `Temp User` link will be added to the nav bar leading to the 
 * resource temporary users screen.
 */
function processRelationship(molten, relationship, options) {
  // Get parameters
  const {
    blueprint
  } = relationship;

  // Check if blueprint has temporary management
  if (!blueprint.hasTag('has:tempUserManagement')) {
    return;
  }

  // Initialize parameters
  const actionPath = `${relationship.urlPath}/${relationship.isGroup ? `:${blueprint.type}Id/` : ''}temporaryAccess`;

  // Add link
  molten.addPlugin('Action', TemporaryUserLinkAction.create(molten, relationship, {
    actionPath,
    t,
    tf,
    tIcon,
    tfIcon
  }));

  // Add Breadcrumbs
  molten.addPlugin('Route', TemporaryUserBreadcrumbRouteCreator.create(molten, relationship, {
    actionPath,
    t,
    tf,
    tIcon,
    tfIcon
  }));
  // Add route
  molten.addPlugin('Route', TemporaryUserRouteCreator.create(molten, relationship, {
    actionPath,
    t,
    tf,
    tIcon,
    tfIcon
  }));
  molten.addPlugin('Action', {
    matches: [{
      use: ['contextMenu', 'mobileActionBar'],
      path: relationship.path,
      objectType: relationship?.blueprint?.type
    }, {
      client: ['ListDataViewer'],
      use: ['contextMenu', 'mobileActionBar']
    }],
    ...CreateTemporaryUserAction.create({
      relationship,
      molten
    })
  });
}
export default {
  processRelationship
};